import { routerApp, baseUrl, enableOnPremise } from '../app.module';
import angular from 'angular';
import { httpRequestGenerator } from './utilities';

routerApp.factory('ManagementUsersService', ['$http', '$log', function($http: angular.IHttpService, $log: angular.ILogService) {
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);
    return {
        getUsers: (clientId: string = null) => {
            return requestFunc({
                url: `${baseUrl}v1/management/users/` + (clientId ? `?client_id=${clientId}` : ''),
                method: 'GET'
            });
        },
        getUser: (userId: string) => {
            return requestFunc({
                url: `${baseUrl}v1/management/users/${userId}`,
                method: 'GET'
            });
        },
        createUser: (user: any) => {
            return requestFunc({
                url: `${baseUrl}v1/management/users/`,
                method: 'POST',
                data: user
            });
        },
        updateUser: (userId: string, user: any) => {
            return requestFunc({
                url: `${baseUrl}v1/management/users/${userId}`,
                method: 'PUT',
                data: user
            });
        },
        deleteUser: (userId: string) => {
            return requestFunc({
                url: `${baseUrl}v1/management/users/${userId}`,
                method: 'DELETE'
            });
        }
    }
}]);